import { render, staticRenderFns } from "./DisplayAttachments.vue?vue&type=template&id=72920e5a&scoped=true&"
import script from "./DisplayAttachments.vue?vue&type=script&lang=js&"
export * from "./DisplayAttachments.vue?vue&type=script&lang=js&"
import style0 from "./DisplayAttachments.vue?vue&type=style&index=0&id=72920e5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72920e5a",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
